import React from 'react';
import {CuentaTransferenciaTerceros} from "../types/types";
import {Grid} from "@mui/material";
import {OperacionTransferenciaTercerosCuentaFields, OperacionTransferenciaTercerosDetalleFields} from "../types/fields";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import {FieldView} from '../../../components/FieldView';

interface TransferenciaTercerosCuentaProps {
  cuenta: CuentaTransferenciaTerceros,
  idOperacion: number,
  codPais: number,
  permiteEditar?: boolean,
  permiteEliminar?: boolean,
  refetch: () => void
}

function TransferenciaTercerosCuenta({cuenta}: TransferenciaTercerosCuentaProps) {
  return (
    <Grid container spacing={2}>
      <Grid item md={3} xs={6}>
        <FieldView label='Número de cuenta' value={cuenta[OperacionTransferenciaTercerosCuentaFields.NroCuenta]} />
      </Grid>
      <Grid item md={3} xs={6}>
        <FieldView label='Titular' value={cuenta[OperacionTransferenciaTercerosCuentaFields.Titular]} />
      </Grid>
      <Grid item md={3} xs={6}>
        <FieldView label='Tipo Operación' value={cuenta[OperacionTransferenciaTercerosCuentaFields.TipoOperacion]} />
      </Grid>
      {cuenta?.[OperacionTransferenciaTercerosCuentaFields.Broker] && (
        <Grid item md={3} xs={6}>
          <FieldView label='Broker' value={cuenta[OperacionTransferenciaTercerosCuentaFields.Broker]} />
        </Grid>
      )}
      {cuenta?.[OperacionTransferenciaTercerosCuentaFields.MSB] && (
        <Grid item md={3} xs={6}>
          <FieldView label='MSB' value={cuenta[OperacionTransferenciaTercerosCuentaFields.MSB]} />
        </Grid>
      )}
      {cuenta?.[OperacionTransferenciaTercerosCuentaFields.BancoReceptor] && (
        <Grid item md={3} xs={6}>
          <FieldView label='Banco Receptor' value={cuenta[OperacionTransferenciaTercerosCuentaFields.BancoReceptor]} />
        </Grid>
      )}
      {cuenta?.[OperacionTransferenciaTercerosCuentaFields.TitularCuenta] && (
        <Grid item md={3} xs={6}>
          <FieldView label='Titular Cuenta' value={cuenta[OperacionTransferenciaTercerosCuentaFields.TitularCuenta]} />
        </Grid>
      )}
      {cuenta[OperacionTransferenciaTercerosCuentaFields.Detalles].map((detalle, index) => (
        <React.Fragment key={index}>
          <Grid item md={3} xs={6}>
            <FieldView label='Moneda' value={detalle[OperacionTransferenciaTercerosDetalleFields.Moneda]} />
          </Grid>
          <Grid item md={3} xs={6}>
            <FieldView label='Monto' value={numberFormatter.toStringWithDecimals(detalle[OperacionTransferenciaTercerosDetalleFields.Monto])} />
          </Grid>
          {detalle?.[OperacionTransferenciaTercerosDetalleFields.MontoEquivalenteUSD] && (
            <Grid item md={3} xs={6}>
              <FieldView label='Monto Equivalente USD' value={detalle?.[OperacionTransferenciaTercerosDetalleFields.MontoEquivalenteUSD]} />
            </Grid>
          )}
          <Grid item md={3} xs={6}>
            <FieldView label='Destino' value={detalle[OperacionTransferenciaTercerosDetalleFields.Destino]} />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}

export default TransferenciaTercerosCuenta;